
const applicantInfos =  {
    APPLICANT_UL: [ // Юридическое лицо
      {
        prop: 'NameFull',
        label: 'Полное название',
        group: 'Данные организации'
      }, {
        prop: 'NameShort',
        label: 'Сокращенное название',
        group: 'Данные организации'
      }, {
        prop: 'INN',
        label: 'ИНН',
        group: 'Данные организации'
      }, {
        prop: 'Egrul',
        label: 'ЕГРЮЛ',
        group: 'Данные организации'
      }, {
        prop: 'EgrulDate',
        label: 'Дата выдачи ЕГРЮЛ',
        group: 'Данные организации'
      }, {
        prop: 'OKVED',
        label: '',
        group: 'Данные организации'
      },
      
      {
        prop: 'ContactPerson.LastName',
        label: 'Фамилия',
        group: 'Данные руководителя организации'
      }, {
        prop: 'ContactPerson.Name',
        label: 'Имя',
        group: 'Данные руководителя организации'
      }, {
  
        prop: 'ContactPerson.MiddleName',
        label: 'Отчество',
        group: 'Данные руководителя организации'
      }, {
        prop: 'ContactPerson.Title',
        label: 'Должность',
        group: 'Данные руководителя организации'
      }, {
        prop: 'ContactPerson.OnBasis',
        label: 'Основание должности',
        group: 'Данные руководителя организации'
      },
  
      {
        prop: 'Representative.LastName',
        label: 'Фамилия',
        group: 'Данные лица, подписывающего документы'
      }, {
        prop: 'Representative.Name',
        label: 'Имя',
        group: 'Данные лица, подписывающего документы'
      }, {
  
        prop: 'Representative.MiddleName',
        label: 'Отчество',
        group: 'Данные лица, подписывающего документы'
      },
      /* {
        prop: 'Representative.Title',
        label: 'Должность',
        group: 'Данные лица, подписывающего документы'
      }, {
        prop: 'Representative.OnBasis',
        label: 'Основание должности',
        group: 'Данные лица, подписывающего документы'
      },
  */
  
      
  
      {
        prop: 'FakticAddress.Region',
        label: 'Регион',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.Area',
        label: 'Район',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.Street',
        label: 'Улица',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.House',
        label: 'Дом',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.Flat',
        label: 'Квартира / офис',
        group: 'Юридический адрес'
      }, {
        prop: 'FakticAddress.Index',
        label: 'Индекс	',
        group: 'Юридический адрес'
      },
  
      {
        prop: 'PostAddress.Region',
        label: 'Регион',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.Area',
        label: 'Район',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.Street',
        label: 'Улица',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.House',
        label: 'Дом',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.Flat',
        label: 'Квартира / офис',
        group: 'Почтовый адрес'
      }, {
        prop: 'PostAddress.Index',
        label: 'Индекс	',
        group: 'Почтовый адрес'
      },
  
      {
        prop: 'BankAccount.Bank',
        label: 'Наименование банка',
        group: 'Банковские реквизиты'
      }, {
        prop: 'BankAccount.RS',
        label: 'Расчетный счет',
        group: 'Банковские реквизиты'
      }, {
  
        prop: 'BankAccount.KS',
        label: 'Корреспондентский счет',
        group: 'Банковские реквизиты'
      }, {
        prop: 'BankAccount.BIK',
        label: 'БИК',
        group: 'Банковские реквизиты'
      }, {
        prop: 'KPP',
        label: 'КПП',
        group: 'Данные организации'
      }
  
      
  
    ],
    APPLICANT_PHIZ: [{
        prop: 'LastName',
        label: 'Фамилия',
        group: 'Личные данные'
      }, {
        prop: 'Name',
        label: 'Имя',
        group: 'Личные данные'
      }, {
        prop: 'MiddleName',
        label: 'Отчество',
        group: 'Личные данные'
      }, {
        prop: 'Gender',
        label: 'Пол',
        group: 'Личные данные'
      }, {
        prop: 'Snils',
        label: 'СНИЛС',
        group: 'Личные данные'
      }, {
  
        prop: 'Document.TypeDocumentWeb',
        label: 'Тип документа',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Serial',
        label: 'Серия',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Number',
        label: 'Номер',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.FromDate',
        label: 'Дата выдачи',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Org',
        label: 'Кем выдан',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.DepCode',
        label: 'Код подразделения',
        group: 'Удостоверение личности заявителя'
      },
      {
        prop: 'RegisteredAddress.Region',
        label: 'Регион',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Area',
        label: 'Район',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Street',
        label: 'Улица',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.House',
        label: 'Дом',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Flat',
        label: 'Квартира / офис',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Index',
        label: 'Индекс	',
        group: 'Постоянная регистрация'
      },
  
      {
        prop: 'ActualAddress.Region',
        label: 'Регион',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Area',
        label: 'Район',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Street',
        label: 'Улица',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.House',
        label: 'Дом',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Flat',
        label: 'Квартира / офис',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Index',
        label: 'Индекс	',
        group: 'Почтовый адрес'
      },
  
  
  
  
    ],
    APPLICANT_IP: [{
        prop: 'LastName',
        label: 'Фамилия',
        group: 'Личные данные'
      }, {
        prop: 'Name',
        label: 'Имя',
        group: 'Личные данные'
      }, {
        prop: 'MiddleName',
        label: 'Отчество',
        group: 'Личные данные'
      }, {
        prop: 'Egrip',
        label: 'ЕГРИП',
        group: 'Личные данные'
      }, {
        prop: 'EgripDate',
        label: 'Дата выдачи ЕГРИП',
        group: 'Личные данные'
      }, {
        prop: 'INN',
        label: 'ИНН',
        group: 'Личные данные'
      }, {
        prop: 'Gender',
        label: 'Пол',
        group: 'Личные данные'
      }, {
  
        prop: 'Document.TypeDocumentWeb',
        label: 'Тип документа',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Serial',
        label: 'Серия',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Number',
        label: 'Номер',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.FromDate',
        label: 'Дата выдачи',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.Org',
        label: 'Кем выдан',
        group: 'Удостоверение личности заявителя'
      }, {
        prop: 'Document.DepCode',
        label: 'Код подразделения',
        group: 'Удостоверение личности заявителя'
      },
      {
        prop: 'RegisteredAddress.Region',
        label: 'Регион',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Area',
        label: 'Район',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Street',
        label: 'Улица',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.House',
        label: 'Дом',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Flat',
        label: 'Квартира / офис',
        group: 'Постоянная регистрация'
      }, {
        prop: 'RegisteredAddress.Index',
        label: 'Индекс',
        group: 'Постоянная регистрация'
      },
      {
        prop: 'ActualAddress.Region',
        label: 'Регион',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Area',
        label: 'Район',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.City',
        label: 'Город / Населённый пункт',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Street',
        label: 'Улица',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.House',
        label: 'Дом',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Construction',
        label: 'Стр./Влад./Кор.',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Flat',
        label: 'Квартира / офис',
        group: 'Почтовый адрес'
      }, {
        prop: 'ActualAddress.Index',
        label: 'Индекс	',
        group: 'Почтовый адрес'
      },
  
      {
        prop: 'BankAccount.Bank',
        label: 'Наименование банка',
        group: 'Банковские реквизиты'
      }, {
        prop: 'BankAccount.RS',
        label: 'Расчетный счет',
        group: 'Банковские реквизиты'
      }, {
  
        prop: 'BankAccount.KS',
        label: 'Корреспондентский счет',
        group: 'Банковские реквизиты'
      }, {
        prop: 'BankAccount.BIK',
        label: 'БИК',
        group: 'Банковские реквизиты'
      }
  
  
    ]
}
  
  
  const applicantTypes={
    APPLICANT_UL: 'ul', // Юридическое лицо
    APPLICANT_PHIZ: 'fl', // Физическое лицо
    APPLICANT_IP: 'ip', //Индивидуальный предприниматель
  }
  
  
  const applicantFiles={
    APPLICANT_UL: {
      YUR_DOC_CHARTER: 'Устав',
      YUR_DOC_CARD_ORG: 'Карточка организации',
      YUR_DOC_LEGAL_INF: 'Свидетельство о постановке на учет в налоговом органе ',
      YUR_DOC_BIN: 'ОГРН',
      V_EGRUL: 'Выписка ЕГРЮЛ',
      BOSS_DOC_CONFIRM: 'Подтверждение полномочий руководителя',
    }, // Юридическое лицо
    APPLICANT_PHIZ: {
      INN:'Копия ИНН'
      //  REP_DOCUMENT      : 'Документы подтверждающие полномочия представителя',
    }, // Физическое лицо
    APPLICANT_IP: {
      StatementFromEGRUL_EGRIP: 'Свидетельство о постановке на учет в ЕГРИП',
      INN:'Копия ИНН'
    }, // Индивидуальный предприниматель
  }
  
  const referenceEntity={
    BID: 'bid',
    APPEAL: 'appeal',
  
  }

export { 
      applicantInfos,
      applicantTypes,
      applicantFiles,
      referenceEntity


};



// WEBPACK FOOTER //
// ./src/app.constants.js